module.exports = "images/map_huge_2.png";